/* ==========================================================================
   Ryse - Theoric: ROLAGEM DE DIGITOS

   Troca um valor por outro fazendo os digitos que mudaram DESLIZAREM: o antigo
   sobe e sai, o novo entra por baixo. Os que nao mudaram ficam parados.

   ==========================  POR QUE NAO "DIGITACAO"  =======================
   Romulo pediu "um efeito de digitacao ou algo assim" nos valores. Efeito de
   maquina de escrever num PRECO tem um problema que nao e de gosto:

     R$ 4        <- existe. E um preco. E esta errado.
     R$ 44       <- idem
     R$ 448      <- idem
     R$ 448,20   <- so agora e verdade

   Durante ~300ms a tela afirma valores que a loja nao vai cobrar. Em cima de um
   rotulo de marketing isso e charme; em cima do numero que a pessoa vai pagar,
   e uma frase que se contradiz no meio. O mesmo vale para a contagem
   (interpolar 498,00 -> 448,20): cada quadro e um preco inteiro e falso.

   A rolagem nao inventa nada: ha o valor antigo saindo e o novo entrando, e o
   olho le isso como transicao, nao como leitura. Movimento sem mentira.

   ==========================================================================
   >>> O BUG DO PRECO VOANDO PELA TELA (Romulo, 11/07/2026) <<<

   "quando um produto e adicionado ao carrinho, o preco aparece num lugar bem
    aleatorio rodando a animacao de roller"

   Medido, no instante da rolagem:

       div.cart-item__totals  ->  x = -311px , largura = 699px

   Numa gaveta de 400px. O elemento inchou para 699px e, como a coluna do preco
   e `position:absolute; right:0`, ela cresceu PARA A ESQUERDA - jogando o preco
   para fora da gaveta, por cima do texto que estivesse ali.

   A CAUSA:
   Quando o tema redesenha o card, o HTML vem direto do Liquid. E o
   .cart-item__totals NAO contem "R$ 249,00". Contem:

       "\n                   R$ 249,00\n        "

   ...com as quebras de linha e a indentacao do arquivo .liquid.

   Eu comparava el.textContent CRU com o valor formatado. Nunca sao iguais - o
   rolo disparava sempre. E, pior, cada espaco em branco virava UMA CELULA DE
   ROLAGEM: 30+ celulas em vez de 9. Dai os 699px.

   O que me enganou: medi esse elemento antes e vi "R$ 249,00" limpinho. Mas era
   um card que NOS ja tinhamos pintado (e textContent = ... limpa o whitespace).
   No card recem-nascido do tema, o lixo esta la.

   >>> LICAO: textContent de markup do Liquid vem com a indentacao junto. <<<
   >>> Comparou texto de servidor com texto formatado? NORMALIZE OS DOIS.  <<<
   ==========================================================================

   REGRAS QUE ESTE ARQUIVO SEGUE

   1. NORMALIZA ANTES DE COMPARAR (ver acima). E, se ja estiver certo, ainda
      assim reescreve o textContent limpo - assim a proxima comparacao parte de
      um DOM sem lixo.

   2. NAO ANIMA NA PRIMEIRA PINTURA. Se o elemento esta vazio, o valor aparece
      direto. Animar a entrada faria o preco "chegar" - e ele nao chegou, sempre
      esteve la. Movimento tem que significar MUDANCA.

   3. TETO DE SEGURANCA. Se a troca exigiria mais celulas do que um preco
      plausivel (LIMITE_CELULAS), nao rola: troca seco. Um valor certo sem
      animacao e sempre melhor que uma animacao certa num valor errado - e foi
      exatamente a falta desse teto que deixou o bug acima chegar na tela.

   4. ALINHA PELA DIREITA. "R$ 98,00" e "R$ 448,20" tem tamanhos diferentes;
      alinhados pela esquerda, o centavo rolaria por cima da centena.

   5. VOLTA A SER TEXTO. Terminada a animacao, o innerHTML de <span> vira um no
      de texto puro de novo. Sobra de animacao ja terminada e lixo no DOM.

   6. prefers-reduced-motion: troca direta. Nada some, so para de se mexer.

   7. aria-busy durante o movimento: o valor fica picado em <span> por 400ms, e
      quem usa leitor de tela precisa saber que aquilo ainda esta se assentando.

   Carregado por sections/cart-theoric.liquid, DEPOIS do nucleo.
   Usado por theoric-cart-extras.js (o Total) e theoric-cart-item.js (o preco do
   card). Pix, parcelas e frete continuam com o fade discreto: se tudo rolar ao
   mesmo tempo, a gaveta vira caca-niquel.
   ========================================================================== */
(function () {
  'use strict';

  if (window.TheoricRolar) return;

  var DURACAO = 460;        // ms de cada digito
  var ESCADA = 40;          // ms de atraso entre um digito e o proximo
  var LIMITE_CELULAS = 20;  // teto de seguranca (ver regra 3)
  var ESPACO = ' ';      // nbsp: um espaco comum colapsaria no HTML

  function reduzMovimento() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  /* >>> A funcao que faltava. <<<
     O texto que vem do Liquid traz a indentacao do arquivo junto. Comparar isso
     com um valor formatado nunca da igual - e cada espaco vira uma celula. */
  function limpar(texto) {
    return String(texto == null ? '' : texto).replace(/\s+/g, ' ').trim();
  }

  function alturaDe(el) {
    var s = getComputedStyle(el);
    var h = parseFloat(s.lineHeight);
    if (!h || isNaN(h)) h = Math.round(parseFloat(s.fontSize) * 1.2);
    return Math.round(h);
  }

  function preencherAEsquerda(texto, n) {
    var s = String(texto);
    while (s.length < n) s = ESPACO + s;
    return s;
  }

  function rolar(el, texto) {
    if (!el) return;

    var alvo = limpar(texto);
    var atual = limpar(el.textContent);

    /* Ja esta certo. Mesmo assim reescrevemos o textContent - o DOM pode conter
       o whitespace do Liquid, e a proxima comparacao tem que partir do limpo. */
    if (atual === alvo) {
      if (el.textContent !== alvo) el.textContent = alvo;
      return;
    }

    var n = Math.max(atual.length, alvo.length);

    /* Primeira pintura, movimento reduzido, elemento sem layout, ou troca grande
       demais para ser um preco: TROCA SECO.
       O elemento sem layout importa: rolar algo que ainda nao foi posicionado
       produz celulas com altura errada - e foi assim que o preco foi parar
       fora da tela. */
    if (!atual ||
        reduzMovimento() ||
        n > LIMITE_CELULAS ||
        el.offsetParent === null) {
      el.textContent = alvo;
      return;
    }

    var altura = alturaDe(el);
    var velho = preencherAEsquerda(atual, n);
    var novo = preencherAEsquerda(alvo, n);

    el.innerHTML = '';
    el.setAttribute('aria-busy', 'true');

    var atraso = 0;

    for (var i = 0; i < n; i++) {
      var a = velho[i];
      var b = novo[i];

      // caractere igual: nao se mexe. So rola o que de fato mudou.
      if (a === b) {
        var fixo = document.createElement('span');
        fixo.className = 'theoric-rolo__fixo';
        fixo.textContent = b;
        el.appendChild(fixo);
        continue;
      }

      var cela = document.createElement('span');
      cela.className = 'theoric-rolo';
      cela.style.height = altura + 'px';

      var coluna = document.createElement('span');
      coluna.className = 'theoric-rolo__col';

      var de = document.createElement('span');
      de.textContent = a;
      de.style.height = altura + 'px';
      de.style.lineHeight = altura + 'px';

      var para = document.createElement('span');
      para.textContent = b;
      para.style.height = altura + 'px';
      para.style.lineHeight = altura + 'px';

      coluna.appendChild(de);
      coluna.appendChild(para);
      cela.appendChild(coluna);
      el.appendChild(cela);

      // dois rAF: o primeiro deixa o navegador registrar a posicao inicial.
      // Sem isso a transicao nao tem "de onde" partir e o digito so aparece.
      (function (c, ms) {
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            setTimeout(function () {
              c.style.transform = 'translateY(-' + altura + 'px)';
            }, ms);
          });
        });
      })(coluna, atraso);

      atraso += ESCADA;
    }

    /* Fim: o elemento volta a ser texto puro. Se uma nova rolagem comecar antes
       desta acabar, o timer antigo e cancelado - senao ela escreveria o valor
       velho por cima do novo. */
    clearTimeout(el.__rolo);
    el.__rolo = setTimeout(function () {
      el.textContent = alvo;
      el.removeAttribute('aria-busy');
    }, atraso + DURACAO + 40);
  }

  window.TheoricRolar = { trocar: rolar, limpar: limpar };
})();
